module.exports = __webpack_public_path__ + "d57bdb3c983d17f8a829f5e3b5b50323.svg";